import { VueCookieNext } from 'vue-cookie-next'

export default function useIsBeta() {
    return VueCookieNext.getCookie('profile')?.beta_tester ?? false
}